<template>
    <IOContainer :maxHeight="maxHeight">
        <div
            v-if="record.output && record.output.arupComputeReport_HTML"
            v-katex:auto="{ options: katexOptions }"
            v-html="record.output.arupComputeReport_HTML"
            class="v-card__text"
        ></div>
        <p v-else style="text-align: center" class="text-body-large">
            No report output
        </p>
    </IOContainer>
</template>
<script setup>
import { ref } from 'vue'
import IOContainer from '../shared/IOContainer.vue'

const props = defineProps({
    record: {
        type: Object,
        required: true,
    },
    maxHeight: {
        type: String,
        default: '100%',
    },
})

const katexOptions = ref({
    delimiters: [{ left: '$$', right: '$$', display: false }],
})
</script>
